import { render } from "./Spaces.vue?vue&type=template&id=2a05b172&scoped=true"
import script from "./Spaces.vue?vue&type=script&lang=ts"
export * from "./Spaces.vue?vue&type=script&lang=ts"

import "./Spaces.vue?vue&type=style&index=0&id=2a05b172&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a05b172"

export default script